import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import './index.css';

import SplashScreen from './Screens/SplashScreen';
import LoginScreen from './Screens/LoginScreen';
import BookingScreen from './Screens/BookingScreen';
import HomeScreen from './Screens/HomeScreen';
import MembershipScreen from './Screens/MembershipScreen';
import ProfileScreen from './Screens/ProfileScreen';
import RewardScreen from './Screens/RewardScreen';
import { TooltipProvider } from './components/ui/tooltip';
import UseDarkMode from './Elements/UseDarkMode';
import { AuthProvider } from './Services/AuthContext';
import BookingHistoryScreen from './Screens/BookingHistoryScreen';
import WalkInHistoryScreen from './Screens/WalkInHistoryScreen';
import { Bounce, ToastContainer } from 'react-toastify';
import AuthGuard from './Elements/AuthGuard';

// import "@radix-ui/themes/styles.css";
// import { Theme } from '@radix-ui/themes';


const qc = new QueryClient();

const root = document.getElementById('root');

const UseDarkModeProvider = (props) => {
  const [isDarkMode, toggleDarkMode] = UseDarkMode();
  return props.children
}



ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <QueryClientProvider client={qc}>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
        transition={Bounce}
      />
      <AuthProvider>
        <UseDarkModeProvider>
          <TooltipProvider delayDuration={100}>
            <BrowserRouter basename="/portal">
              <Routes>
                <Route path="/" element={<AuthGuard><SplashScreen /></AuthGuard>} />
                <Route path="/login" element={<LoginScreen />} />
                <Route path="/booking" element={<AuthGuard><BookingScreen /></AuthGuard>} />
                <Route path="/booking/history" element={<AuthGuard><BookingHistoryScreen /></AuthGuard>} />
                <Route path="/history" element={<AuthGuard><WalkInHistoryScreen /></AuthGuard>} />
                <Route path="/home" element={<AuthGuard><HomeScreen /></AuthGuard>} />
                <Route path="/funpass" element={<AuthGuard><MembershipScreen /></AuthGuard>} />
                <Route path="/profile" element={<AuthGuard><ProfileScreen /></AuthGuard>} />
                <Route path="/rewards" element={<AuthGuard><RewardScreen /></AuthGuard>} />
              </Routes>
            </BrowserRouter>
          </TooltipProvider>
        </UseDarkModeProvider>
      </AuthProvider>
    </QueryClientProvider>
  </React.StrictMode>
);
